import { useTranslation } from 'react-i18next';

const useCustomTranslation = () => {
  const { t } = useTranslation();
  const namespace = (process.env.REACT_APP_CUSTOMER_CONFIG || 'default').trim();
  const customT = (key: string) => t(`${namespace}::${key}`);

  return { t: customT };
};

export default useCustomTranslation;
